import { render, staticRenderFns } from "./emailTemplatesList.vue?vue&type=template&id=505b0fc8&scoped=true"
import script from "./emailTemplatesList.vue?vue&type=script&lang=js"
export * from "./emailTemplatesList.vue?vue&type=script&lang=js"
import style0 from "./emailTemplatesList.vue?vue&type=style&index=0&id=505b0fc8&prod&lang=scss&scoped=true"
import style1 from "./emailTemplatesList.vue?vue&type=style&index=1&id=505b0fc8&prod&lang=scss"
import style2 from "./emailTemplatesList.vue?vue&type=style&index=2&id=505b0fc8&prod&lang=scss&scoped=true"
import style3 from "./emailTemplatesList.vue?vue&type=style&index=3&id=505b0fc8&prod&lang=scss"
import style4 from "./emailTemplatesList.vue?vue&type=style&index=4&id=505b0fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b0fc8",
  null
  
)

export default component.exports